import React, { useMemo } from 'react'
import { Navigate, Route, useLocation } from 'react-router-dom'
import { PATHS } from 'utils/paths'
import { isNotNilOrEmpty } from 'utils/ramda'
import GlobalLoader from './GlobalLoader'

const PrivateRoute = ({ allowedRoles, userRole = null, children }) => {
  const location = useLocation()
  const hasValidRole = useMemo(() => {
    return userRole && allowedRoles ? allowedRoles.includes(userRole) : false
  }, [userRole])

  if (isNotNilOrEmpty(userRole)) {
    // Preserve the original destination so login → success can return the
    // user there (otherwise share / deeplink URLs are lost on auth bounce).
    return hasValidRole
      ? children
      : <Navigate to={PATHS.login} state={{ from: location }} replace />
  } else {
    return <div />
  }
}

export default PrivateRoute
